import { Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { getHorizontalAlignment } from "../../../../viewer/chart/style/legend/getHorizontalAlignment.ts";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { selectChartSettingsState } from "../../../../../store/selectors/fieldsStateSelectors.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import type { LegendSettings } from "../../../../../../../../../api/types/svTypes.ts";

export default function HorizontalAlignmentItem({ readonlyMode }: { readonlyMode: boolean }) {
  const settings = useSelector(selectChartSettingsState);
  const alignment = React.useMemo(() => getHorizontalAlignment(settings), [settings]);
  const dispatch = useAppDispatch();

  return (
    <Stack direction="row" sx={{ alignItems: "center" }}>
      <Typography sx={{ color: "text.secondary" }}>Horizontal Alignment</Typography>
      <HorizontalFill />
      <ToggleButtonGroup
        exclusive
        color="primary"
        value={alignment}
        disabled={readonlyMode}
        onChange={(_, value: LegendSettings["horizontalAlignment"]) => {
          if (value !== null) dispatch(fieldsStateActions.updateLegendSettings({ horizontalAlignment: value }));
        }}
      >
        <ToggleButton value="left" sx={{ py: 0.3, fontWeight: 400 }}>
          Left
        </ToggleButton>
        <ToggleButton value="center" sx={{ py: 0.3, fontWeight: 400 }}>
          Center
        </ToggleButton>
        <ToggleButton value="right" sx={{ py: 0.3, fontWeight: 400 }}>
          Right
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
}
